import { Waveform } from "../../../interfaces/vitals/Waveform";
import { PIXELS_PER_MV } from "./LiveUnitWaveforms";

export interface DrawInfo {
    colorVar: string;
    range_min: number;
    range_max: number;
  }

  /*
const arrAvg = (arr: number[]) =>
    arr.reduce((a: number, b: number) => a + b, 0) / arr.length;

const ECG_WAVEFORMS = [
    "ECG_L1",
    "ECG_L2",
    "ECG_L3",
    "ECG_V",
    "ECG_AVR",
    "ECG_AVL",
    "ECG_AVF",
    "ECG_Defi",
  ];

*/
  export const waveDrawInfo_Touch7: { [name: string]: DrawInfo } = {
    ECG_L1:   { colorVar: "--parm-color-hr",   range_min:-1, range_max:1 },
    ECG_L2:   { colorVar: "--parm-color-hr",   range_min: -1, range_max: 1 },
    ECG_L3:   { colorVar: "--parm-color-hr",   range_min: -1, range_max: 1 },
    ECG_Defi: { colorVar: "--parm-color-hr",   range_min: -1, range_max: 1 },
    SpO2:     { colorVar: "--parm-color-spo2", range_min: -200, range_max: 200 },
    Resp:     { colorVar: "--parm-color-resp", range_min: -127, range_max: 128 },
    IBP1:     { colorVar: "--parm-color-ibp1", range_min: 0, range_max: 1 },
    EtCO2:    { colorVar: "--parm-color-resp", range_min: 0, range_max: 4 },
  };

export const waveDrawInfo_APLC3: { [name: string]: DrawInfo } = {
  // TODO: Backend indicates presence of IBP2/3/4 waveforms, but we're making an exception 
  // to only support IBP1 waveform for now. In the future we will support the other waveforms.
  ...waveDrawInfo_Touch7,
  // APLC3 sends IBP values in mmHg. Narrow range 70-130 to exaggerate waveform visibility
  // This amplifies typical BP values (80-120) for better visualization
  IBP1: { colorVar: "--parm-color-ibp1", range_min: 70, range_max: 130 },
  IBP2: { colorVar: "--parm-color-ibp1", range_min: 70, range_max: 130 },
  IBP3: { colorVar: "--parm-color-ibp1", range_min: 70, range_max: 130 },
  IBP4: { colorVar: "--parm-color-ibp1", range_min: 70, range_max: 130 },
};

  export const waveDrawInfo_Recobro: { [name: string]: DrawInfo } = {
    ECG_L1:   { colorVar: "--parm-color-hr",   range_min: -1, range_max: 1 },
    ECG_L2:   { colorVar: "--parm-color-hr",   range_min: -1, range_max: 1 },
    ECG_L3:   { colorVar: "--parm-color-hr",   range_min: -1, range_max: 1 },
    ECG_AVR:  { colorVar: "--parm-color-hr",   range_min: -1, range_max: 1 },
    ECG_AVL:  { colorVar: "--parm-color-hr",   range_min: -1, range_max: 1 },
    ECG_AVF:  { colorVar: "--parm-color-hr",   range_min: -1, range_max: 1 },
    ECG_V:    { colorVar: "--parm-color-hr",   range_min: -1, range_max: 1 },
    SpO2:     { colorVar: "--parm-color-spo2", range_min: -100, range_max: 100 },
    Resp:     { colorVar: "--parm-color-resp", range_min: -127, range_max: 128 },
    IBP1:     { colorVar: "--parm-color-ibp1", range_min: 0, range_max: 180 },
    IBP2:     { colorVar: "--parm-color-ibp1", range_min: 0, range_max: 180 },
    IBP3:     { colorVar: "--parm-color-ibp1", range_min: 0, range_max: 180 },
    IBP4:     { colorVar: "--parm-color-ibp1", range_min: 0, range_max: 180 },
    EtCO2:    { colorVar: "--parm-color-resp", range_min: 0, range_max: 100 },
    ACT:      { colorVar: "--parm-color-act",  range_min: 0, range_max: 24 },
  };


const waveDrawInfoMap: { [key: string]: { [name: string]: DrawInfo } } = {
  "Defigard Touch 7": waveDrawInfo_Touch7,
  "Recobro v2": waveDrawInfo_Recobro,
  "APLC3": waveDrawInfo_APLC3,
};

export interface WaveformPixel {
    value: number;
    color: string;
}

/*
 * Convert sample buffer entries to pixels - scale according to number of pixels per second.
 */
export const makePixels = (
    waveform: Waveform,
    pixels_per_second: number,
    swimlane_height: number,
    deviceModel: string     // "Recobro v2" or "Defigard Touch 7"
  ) => {
    //console.log ("deviceModel:", deviceModel)
    const pixels: WaveformPixel[] = [];
    const samplerate: number = waveform.samplerate;
//    const correct_mean: boolean = ECG_WAVEFORMS.includes(waveform.name);
    const samples: number[] = waveform.samples;
    const sampleValidity: number[] = waveform.sampleValidity;
    
    // Default fallback DrawInfo for unknown waveforms
    const defaultDrawInfo: DrawInfo = { colorVar: "--parm-color-hr", range_min: -1, range_max: 1 };
    
    // Try device-specific map, then Touch7, then default - initialize with default
    let myDrawInfo: DrawInfo = defaultDrawInfo;
    if (waveDrawInfoMap[deviceModel]?.hasOwnProperty(waveform.name)) {
        myDrawInfo = waveDrawInfoMap[deviceModel][waveform.name];
    } else if (waveDrawInfoMap["Defigard Touch 7"]?.hasOwnProperty(waveform.name)) {
        myDrawInfo = waveDrawInfoMap["Defigard Touch 7"][waveform.name];
    }
    
    // Safety check - ensure myDrawInfo is valid before proceeding
    if (!myDrawInfo || typeof myDrawInfo.range_max === 'undefined' || typeof myDrawInfo.range_min === 'undefined') {
        console.warn(`Invalid DrawInfo for waveform ${waveform.name} on device ${deviceModel}, using default`);
        myDrawInfo = defaultDrawInfo;
    }
    
    const swimlane_center = swimlane_height * 0.5;
    //console.log (waveform)
    // Pick out which pixels we want based on the viewport resolution.
    // We take every n'th sample calculated by n = samples per second / pixels per second
    // That is the sample rate divided by the pixels per second resolution of the viewport.
  
    const value_range = myDrawInfo.range_max - myDrawInfo.range_min;
    const scalefactor = swimlane_height / value_range;
  
    const n_samples = waveform.samples.length; // number of samples in buffer
    const samples_per_pixel = samplerate / pixels_per_second; // sample/sec * sec/pixel = sample/pixel
    const pixels_per_sample = 1 / samples_per_pixel;
    const n_pixels = Math.floor(n_samples * pixels_per_sample); // pixels = samples
    
    // Reuse myDrawInfo that was safely computed above
    const raw = getComputedStyle(document.documentElement)
                  .getPropertyValue(myDrawInfo.colorVar).trim();
    const cssColor = raw || "#000000";  // fallback if still empty

    // Map samples to pixel values
    var pixel_index = 0;
    var minp = 100, maxp = -100;

    if (waveform.name === "SpO2") {
      //console.log ("SpO2 samples:", samples)
    }
    // IBP data arrives in correct order: rapid rise (systole) then gradual fall (diastole)
    while (pixel_index++ < n_pixels) {
      var sample_index = Math.floor(pixel_index * samples_per_pixel);
      if (sample_index >= n_samples) {
        // Can happen for the last pixel due to floating point arithmetic
        // console.log("Sample index overrun", sample_index, n_samples);
        sample_index = n_samples - 1;
      }
  
      const sample_val = samples[Math.floor(sample_index)];
      const valid_val  = sampleValidity.length > 0 ? sampleValidity[Math.floor(sample_index)] : 0;
      const pixelColor = valid_val !== 0 ? "grey" : cssColor;  

      if (sample_val < minp) minp = sample_val;
      if (sample_val > maxp) maxp = sample_val;


      if (isNaN(sample_val)) {
        //console.log ("NAN detected:", samples[Math.floor(sample_index)], sample_index, samples)
      }
      var pixel_y = sample_val * scalefactor + swimlane_center;
      var d0 = 0;
      switch (waveform.name) {
        case "ECG_L1":
        case "ECG_L2":
        case "ECG_L3":
        case "ECG_V":
        case "ECG_AVR":
        case "ECG_AVL":
        case "ECG_AVF":
        case "ECG_Defi": {
          d0 = pixel_y;
          //console.log (sample_val);
          d0 = sample_val * PIXELS_PER_MV + swimlane_center/2;
          pixels.push({ value: d0, color: pixelColor});
          break;
        }

        case "SpO2":
        case "Resp":
        case "EtCO2":
        case "ACT": {
          d0 = pixel_y;
          pixels.push({ value: d0, color: pixelColor});

          break;
        }
  
  
        case "IBP1":
        case "IBP2":
        case "IBP3":
        case "IBP4": {
          // Log IBP1 samples for debugging
          //if (waveform.name === "IBP1" && pixel_index === 1) {
          //  console.log("IBP1 samples received:", samples.length, "first 10:", samples.slice(0, 10), "last 10:", samples.slice(-10));
          //}
          // Same as SpO2, but center around midpoint of IBP range (values are 70-130 mmHg)
          const mid_val = (myDrawInfo.range_min + myDrawInfo.range_max) / 2;
          d0 = (sample_val - mid_val) * scalefactor + swimlane_center;
          pixels.push({ value: d0, color: pixelColor});
          break;
        }
  
        default: {
          d0 = (sample_val - myDrawInfo.range_min) * scalefactor;
          pixels.push({ value: -d0, color: pixelColor});
        }
      }
    }
    if (waveform.name === "ECG_L2") {
      //console.log (waveform.name, "Min/Max:", minp, maxp, '=', maxp - minp, n_pixels)
    }
    //console.log ("Made num pixels:", n_px_made)
    return pixels;
  }; // makePixels